const TRANSPORTER_ROLES = {
  ROLE: {
    ADMIN: {
      name: 'Admin',
      type: 'admin',
    },
    USER: {
      name: 'User',
      type: 'user',
    },
    PAY_USER: {
      name: 'Pay User',
      type: 'pay_user',
    },
    MANAGE_USER: {
      name: 'Manage User',
      type: 'manage_user',
    },
  },
};

module.exports = { TRANSPORTER_ROLES };
